function showVideo(video) {
    video.classList.remove('financeExampleHeader__video--hide');
}

function hideVideo(video) {
    video.classList.add('financeExampleHeader__video--hide');
}

function showFinanceExample(financeExample) {
    financeExample.classList.remove('financeExample--hidden');
}

function hideFinanceExample(financeExample) {
    financeExample.classList.add('financeExample--hidden');
}

function toggleButtonActive(buttons, financeType) {
    [...buttons].map((b) =>
        b.dataset.value === financeType
            ? b.classList.add('financeExampleToggleButtons__button--active')
            : b.classList.remove('financeExampleToggleButtons__button--active')
    );
}

function elementMatchesFinanceType(element, financeType) {
    return element.getAttribute('data-finance-type') == financeType;
}

function toggle(buttons, button) {
    const financeType = button.getAttribute('data-value'),
        videos = [...document.querySelectorAll('.js_financeExampleHeader__video')],
        financeExamples = [...document.querySelectorAll('.js_financeExample')];

    toggleButtonActive(buttons, financeType)

    videos.filter(video => elementMatchesFinanceType(video, financeType))
        .map(showVideo);

    videos.filter(video => !elementMatchesFinanceType(video, financeType))
        .map(hideVideo);

    financeExamples.filter(financeExample => elementMatchesFinanceType(financeExample, financeType))
        .map(showFinanceExample);

    financeExamples.filter(financeExample => !elementMatchesFinanceType(financeExample, financeType))
        .map(hideFinanceExample);
}

function init() {
    const buttons = document.querySelectorAll('.js_financeExampleToggleButtons__button');
    buttons.forEach((button) => button.addEventListener('click', () => toggle(buttons, button)));
}

$(document).ready(init);
